import { Box, CloseButton, Divider, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/i18n';
import { ChevronLeftSmall } from '@wix/wix-ui-icons-common';
import React from 'react';
import { dataHooks } from '../../../../../utils/datahooks';
export const DrillInScreenHeader = _ref => {
  let {
    onClickBack,
    onClickClose,
    title,
    showDivider = true
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '16px 12px '
    }
  }, /*#__PURE__*/React.createElement(Box, {
    gap: "4px",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(CloseButton, {
    dataHook: dataHooks.a11yWizardHeaderBackButton,
    size: "large",
    skin: "dark",
    onClick: onClickBack
  }, /*#__PURE__*/React.createElement(ChevronLeftSmall, null)), /*#__PURE__*/React.createElement(Text, {
    weight: "bold"
  }, title)), /*#__PURE__*/React.createElement(Box, {
    align: "right"
  }, /*#__PURE__*/React.createElement(CloseButton, {
    "aria-label": t('accessibility-wizard.header.more-action-button.close.aria-label'),
    dataHook: dataHooks.a11yWizardHeaderClosePanelButton,
    size: "large",
    skin: "dark",
    onClick: onClickClose
  }))), showDivider && /*#__PURE__*/React.createElement(Divider, null));
};
//# sourceMappingURL=drill-in-screen-header.js.map